const GET_ASSIGNMENT_TEMPLATE = `query getAssignmentTemplate($entityId: ID!, $entityType: Entity!, $grade: Grade!,$defaultEntities: [DefaultEntity]) {
  assignmentTemplate(entityId: $entityId, entityType: $entityType, grade: $grade,filter: {defaultEntities: $defaultEntities}) {
    assignmentType
    manifest {
      activityType
      locale
      sequence
    }
  }
}
`;

export default GET_ASSIGNMENT_TEMPLATE;
